import { EntityController } from "./EntityController";
import { TulipAssetConstant } from "../TulipAssetConstants";
import { COCOS_PLAN_MODULE_PATH } from "../../constants";
import { PlanManager } from "../../cocosPlan";
import { Commands, ComponentConstants, Events, eventsManager, planManager, roomManager, SceneConstants, TechnicalElement, TechnicalElementType, WallType } from "@rhinov/savane-js";
import { ARRMGR_CLOUDINARY_ALLOWED, ARRMGR_CLOUDINARY_URL, getFrontUrl, getMediaUrl } from "@rhinov/asset-manager-service";




export class TechnicalElementEntityController extends EntityController {

    declare entity: TechnicalElement;
    modelList: any;

    constructor(entity: TechnicalElement, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.modelList = TulipAssetConstant.getinstance().getModelList(this.entity);
        this.updatepreviewWall();
        this.updatepreviewTechnicalElement();
    }

    isWallModelSelected(modele: any): boolean {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.WallType) as WallType;

        if (component !== null) {
            if (component.wallTypeId === modele._id) {
                return (true);
            }
        }

        return (false);
    };


    updateWallModeleType(modele: any) {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.WallType) as WallType;

        if (component !== null) {
            PlanManager.getInstance().executeCommand(new Commands.EditComponentCommand(component, modele._id));
        }
        else {
            PlanManager.getInstance().executeCommand(new Commands.AddComponentCommand(new WallType(modele._id), obj, true, false));
        }
        this.itemPreview = this.getWallPreviewUrl(modele);
    };

    updateTechnicalElementModeleType(modele: any) {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.TechnicalElementType) as TechnicalElementType;

        if (component !== null) {
            PlanManager.getInstance().executeCommand(new Commands.EditComponentCommand(component, modele._id));
        }
        else {
            PlanManager.getInstance().executeCommand(new Commands.AddComponentCommand(new TechnicalElementType(modele._id), obj, true, false));
        }
        this.itemPreview = this.getTechnicalElementPreviewUrl(modele);
            // Update stove dimensions with AssetManager dimensions
        if ((this.entity.objectId === SceneConstants.TechnicalElementType.stove) ||
            (this.entity.objectId === SceneConstants.TechnicalElementType.fireplace) ||
            (this.entity.objectId === SceneConstants.TechnicalElementType.boiler) ||
            (this.entity.objectId === SceneConstants.TechnicalElementType.switchBoard) ||
            (this.entity.objectId === SceneConstants.TechnicalElementType.wallDecoration)) {

            eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                editedProperty: "width",
                value: modele.dimensions.width,
                obj: this.entity
            });
            eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                editedProperty: "length",
                value: modele.dimensions.length,
                obj: this.entity
            });

            if (modele.name.includes("coude") || modele.name.includes("monobloc") || modele.name.includes("suspendu") || (this.entity.objectId === SceneConstants.TechnicalElementType.boiler)) {
                eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                    editedProperty: "height",
                    value: modele.dimensions.height,
                    obj: this.entity
                });

                var floorHeight = 0;

                if (modele.name.includes("suspendu")) {
                    var room = roomManager.getRoomAtPosition(this.entity.position, PlanManager.getInstance().world.currentScene!.currentFloor!);

                    if (room) {
                        floorHeight = room.height - modele.dimensions.height;
                    }
                    else {
                        floorHeight = 2500 - modele.dimensions.height;
                    }
                }

                if (this.entity.objectId === SceneConstants.TechnicalElementType.boiler) {
                    var room = roomManager.getRoomAtPosition(this.entity.position, PlanManager.getInstance().world.currentScene!.currentFloor!);

                    if (!modele.name.includes("socle")) {
                        floorHeight = 1800 - modele.dimensions.height / 2;
                        if (room) {
                            if (floorHeight + modele.dimensions.height > room.height) {
                                floorHeight = room.height - modele.dimensions.height;
                            }
                        }
                    }
                }

                eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                    editedProperty: "floorHeight",
                    value: floorHeight,
                    obj: this.entity
                });
            }
            else {
                if (this.entity.objectId === SceneConstants.TechnicalElementType.switchBoard || this.entity.objectId === SceneConstants.TechnicalElementType.wallDecoration) {
                    eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                        editedProperty: "height",
                        value: modele.dimensions.height,
                        obj: this.entity
                    });
                }
                else {
                    var height = 2500;

                    if (this.entity.objectId === SceneConstants.TechnicalElementType.fireplace && modele.dimensions.height < 2500) {
                        height = modele.dimensions.height;
                    }
                    else {
                        var room = roomManager.getRoomAtPosition(this.entity.position, PlanManager.getInstance().world.currentScene!.currentFloor!);

                        if (room) {
                            height = room.height;
                        }
                    }

                    eventsManager.instance.dispatch(Events.TEXTFIELD_EDIT_ENDED, {
                        editedProperty: "height",
                        value: height,
                        obj: this.entity
                    });
                }
            }

            planManager.snapArrangement(this.entity, PlanManager.getInstance().world.currentScene!.currentFloor!);
        }
    };

    isTechnicalElementModelSelected(modele: any): boolean {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.TechnicalElementType) as TechnicalElementType;

        if (component.technicalElementTypeId === modele._id) {
            return (true);
        }

        return (false);
    }

    openEntityDetail() {
        var path;
        var id;
        switch(this.entity.objectId)
        {
            case SceneConstants.TechnicalElementType.guardrail:
                path = 'decorated-walls/';
                var comp = this.entity.getComponent(ComponentConstants.ComponentType.WallType) as WallType;
                id = comp.wallTypeId;
                break;
            default:
                path = 'technical-elements/';
                var component = this.entity.getComponent(ComponentConstants.ComponentType.TechnicalElementType) as TechnicalElementType;
                id = component.technicalElementTypeId;
                break;
        }
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + id);
            return;
        }
        window.open(getFrontUrl() + path + id);
    };

    openAssetDetail(res: any) {
        var path;
        switch(res.kind)
        {
            case 'TechnicalElement':
                path = 'technical-elements/';
                break;

            case 'DecoratedWall':
                path = "decorated-walls/";
                break;
        }
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + res._id);
            return;
        }
        window.open(getFrontUrl() + path + res._id);
    };

    updatepreviewWall() {
        var component = this.entity.getComponent(ComponentConstants.ComponentType.WallType) as WallType;
        if (component !== null) {
            this.itemPreview = getMediaUrl() + 'decoratedWalls/' + component.wallTypeId + '/medias/previews/preview1-sm.webp';
            if (ARRMGR_CLOUDINARY_ALLOWED) {
                this.itemPreview = ARRMGR_CLOUDINARY_URL + component.wallTypeId + '/medias/previews/preview1-sm.webp';
            }
            let image = document.getElementById('previewTechElem');
            if (image && image.getElementsByTagName("img")[0]) {
                image.getElementsByTagName("img")[0].src = this.itemPreview;
            }
        }
    }

    getWallPreviewUrl(modele: any): string {
        if (modele !== null) {
            var url = getMediaUrl() +
                'decoratedWalls/' +
                modele._id +
                '/medias/previews/preview1-sm.webp';
            if (ARRMGR_CLOUDINARY_ALLOWED) {
                url = ARRMGR_CLOUDINARY_URL + modele._id + '/medias/previews/preview1-sm.webp';
            }
            return (url);
        }
        else {
            return (COCOS_PLAN_MODULE_PATH + "cocos/resources/loading.gif");
        }
    };

    getTechnicalElementPreviewUrl(modele: any): string {
        if (modele !== null) {
            var url = getMediaUrl() +
                'technicalElements/' +
                modele._id +
                '/medias/previews/preview1-sm.webp';
            if (ARRMGR_CLOUDINARY_ALLOWED) {
                url = ARRMGR_CLOUDINARY_URL + modele._id + '/medias/previews/preview1-sm.webp';
            }
            return (url);
        }
        else {
            return (COCOS_PLAN_MODULE_PATH + "cocos/resources/loading.gif");
        }
    };

    updatepreviewTechnicalElement() {
        var component = this.entity.getComponent(ComponentConstants.ComponentType.TechnicalElementType) as TechnicalElementType;
        if (component !== null) {
            this.itemPreview = getMediaUrl() + 'technicalElements/' + component.technicalElementTypeId + '/medias/previews/preview1-sm.webp';
            if (ARRMGR_CLOUDINARY_ALLOWED) {
                this.itemPreview = ARRMGR_CLOUDINARY_URL + component.technicalElementTypeId + '/medias/previews/preview1-sm.webp';
            }
            let image = document.getElementById('previewTechElem');
            if (image && image.getElementsByTagName("img")[0]) {
                image.getElementsByTagName("img")[0].src = this.itemPreview;
            }
        }
    }
}